// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ff-0";
export var actionModalContentContainer = "_ff-1";
export var createTagButton = "_ff-2";
export var footerContainer = "_ff-7";
export var fullWidthDivider = "_ff-3";
export var hasCreateTagButton = "_ff-4";
export var noCreateTagButton = "_ff-5";
export var tagsContainer = "_ff-6";
export var tagsModalContentContainer = "_ff-8";